import React from 'react';
import './HeroBanner.css';

function HeroBanner() {
  return (
    <div className="hero-banner">
      <div className="hero-text-section">
        <h1>
          <span className="hero-headline-main">Discover Upcoming Events.</span>
          <span className="hero-headline-sub">Connect, learn, and celebrate with the International Women’s Club Zagreb community.</span>
        </h1>
      </div>
      <div className="hero-image-section">
        <img src="/iwcz-hat-party.jpg" alt="Hat Party" className="hero-img" />
      </div>
    </div>
  );
}

export default HeroBanner;